/**
 * Extracts content block names from liquid tags in the form {{content_blocks.${name}}}.
 * Handles optional whitespace and id filters (e.g. {{content_blocks.${name} | id: 'abc'}}).
 */
const contentBlockNameRegex = /\{\{\s*content_blocks\.\$\{\s*(.+?)\s*\}\s*(?:\|[^}]*)?\s*\}\}/g;

export const extractContentBlockNames = (...texts: string[]): Set<string> => {
  return texts.reduce((acc, text) => {
    if (!text) {
      return acc;
    }

    for (const match of text.matchAll(contentBlockNameRegex)) {
      const name = match[1]?.trim();
      if (name && name.length > 0) {
        acc.add(name);
      }
    }
    return acc;
  }, new Set<string>());
};
